window.InterWindowCommunicator = class {
    constructor(inboundEvent, outboundEvent, destinationWindow, options = { useLogging: false, logPrefix: '' }) {
        this.inboundEvent = inboundEvent;
        this.outboundEvent = outboundEvent;
        this.destinationWindow = destinationWindow;
        this.listeners = new Map();

        const defaultOptions = {
            useLogging: false,
            logPrefix: '',
        };

        this.options = {
            ...defaultOptions,
            ...(options || {}),
        };

        window.addEventListener('message', event =>
            document.dispatchEvent(new CustomEvent(this.inboundEvent, { detail: event.data }))
        );

        document.addEventListener(this.inboundEvent, event => {
            if (typeof event.detail !== 'object' || !event.detail.command) {
                return;
            }

            if (this.options.useLogging) {
                console.log(`${this.options.logPrefix} receive message`, event.detail);
            }

            if (this.listeners.has(event.detail.command)) {
                this.listeners.get(event.detail.command)(event.detail.data);
            } else {
                Livewire.emit(this.inboundEvent, event.detail);
            }
        });

        document.addEventListener(this.outboundEvent, event => {
            // Checking destinationWindow to prevent circular messages (may happens when page opened not in iframe)
            if (!event.detail || this.destinationWindow === window) {
                return;
            }

            if (this.options.useLogging) {
                console.log(`${this.options.logPrefix} send message`, event.detail);
            }

            this.destinationWindow.postMessage(event.detail, '*');
        });
    }

    emit(command, data) {
        const detail = { command, data };
        const event = new CustomEvent(this.outboundEvent, { detail });

        document.dispatchEvent(event);
    }

    on(command, callback) {
        this.listeners.set(command, callback);
    }

    off(command) {
        this.listeners.delete(command);
    }

    removeAllListeners() {
        this.listeners.clear();
    }
}
